<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<p class="dedi">To John, Beloved of God, and the rest of my Madoni family, with love</p>
<a id="page_viii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication2.vue?40805e3b